import React, { useEffect } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Card, IconButton, CardContent, Typography, Grid, Divider, TextField } from '@mui/material';
import { Tooltip } from '@mui/material';
import OverflowTooltip from '../../helpers/OverflowTooltip';

function Bankdetailss({ employeeData }) {

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 2,
                padding: 3,
                borderRadius: '10px',
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Grid container spacing={2} >
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Bank Name
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '20px' }}><OverflowTooltip>{employeeData?.bank_details.bank_name || 'N/A'}</OverflowTooltip></Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Branch Name
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '20px' }}><OverflowTooltip>{employeeData?.bank_details.branch || 'N/A'}</OverflowTooltip></Typography>
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Account Number
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '20px' }}><OverflowTooltip>{employeeData?.bank_details.account_num || 'N/A'}</OverflowTooltip></Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            IFSC code
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '20px' }}><OverflowTooltip>{employeeData?.bank_details.ifsc || 'N/A'}</OverflowTooltip></Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                        <Typography
                            variant="body1"
                            sx={{ color: '#9E9E9E', fontSize: '14px' }}
                        >
                            Passbook Copy
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                sx={{ color: '#000001DE', fontSize: '20px', width: '100%' }}
                            >
                                <OverflowTooltip>{employeeData?.bank_details?.passbook_copy || 'N/A'}</OverflowTooltip>
                            </Typography>

                            {/* Eye Icon */}
                            {/* <VisibilityIcon
                                sx={{ color: 'blue', fontSize: '20px', cursor: 'pointer' }}
                            /> */}
                        </Box>
                    </Grid>



                </Grid>
            </Box>
        </Box>
    )
}

export default Bankdetailss